var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.652,
    height: 46.663,
    viewBox: "0 0 12.343 12.346",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-215.206 -48.525)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M227.17 53.734l-4.796-4.797a1.407 1.407 0 00-1.99 0l-4.769 4.77a1.407 1.407 0 00.843 2.389v3.186a1.592 1.592 0 001.59 1.59h6.663a1.592 1.592 0 001.59-1.59v-3.186a1.395 1.395 0 00.84-.403 1.411 1.411 0 00.028-1.958zm-2.215 1.697v3.85a.244.244 0 01-.244.244h-6.663a.244.244 0 01-.244-.244v-3.85a.674.674 0 00-.673-.672h-.49l-.03-.001a.057.057 0 01-.04-.017.061.061 0 010-.086l4.766-4.766a.06.06 0 01.085 0l4.757 4.757.01.01a.061.061 0 010 .085.058.058 0 01-.043.018h-.519a.674.674 0 00-.673.673z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 221.379,
    cy: 52.24,
    r: 1.097
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M222.774 54.015a.547.547 0 00-.545-.495h-1.699a.547.547 0 00-.546.494l.323 2.799.225 2.25a.548.548 0 00.547.494h.6a.547.547 0 00.547-.494l.225-2.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton3);
export default __webpack_public_path__ + "static/media/button3.e5afa730.svg";
export { ForwardRef as ReactComponent };